import React from 'react'
import PropTypes from 'prop-types'

import { RenderIf } from '../../../utils/fns'

const TableNotes = ({ isIJoistType, isUSA }) => {
  return (
    <div className="tableNotesWrapper">
      <h4>Table Notes</h4>
      {RenderIf(
        isIJoistType,
        <p>
          * Web Stiffener Required. Refer to current Wood Construction Connectors catalog for&nbsp;
          <a
            target="_blank"
            href="http://www.strongtie.com/productuse/general-notes.html"
            rel="noreferrer"
          >
            General Notes
          </a>
          &nbsp;and&nbsp;
          <a
            target="_blank"
            href="http://www.strongtie.com/productuse/installer.html"
            rel="noreferrer"
          >
            Installation Instructions
          </a>
          .
        </p>,
      )}
      <ol className="space-y-2">
        <li>{`All loads are displayed in units of pounds and based on ${
          isUSA ? 'Allowable Stress Design' : 'Limit States Design'
        }`}</li>
        <li>
          Click on the Models above to be taken to the product page for more information, refer to
          the current Wood Construction Connectors catalog for&nbsp;
          <a
            target="_blank"
            href="http://www.strongtie.com/productuse/general-notes.html"
            rel="noreferrer"
          >
            General Notes
          </a>
          &nbsp;and&nbsp;
          <a
            target="_blank"
            href="http://www.strongtie.com/productuse/installer.html"
            rel="noreferrer"
          >
            Installation Instructions
          </a>
        </li>
      </ol>
    </div>
  )
}

TableNotes.propTypes = {
  isUSA: PropTypes.bool.isRequired,
  isIJoistType: PropTypes.bool.isRequired,
}

export default TableNotes
